// Module-level register for the lead workspace's currently-active lead id.
//
// Read by `bugReportPayload.ts` so submitted reports carry `active_lead_id`
// in `state_snapshot` and `devSyncMetadata` without prop-threading through
// the bug-report panel. Set by the lead workspace whenever the active lead
// changes.
//
// Kept deliberately tiny: no React, no observers. The bug-report payload
// reads on-demand at submit time, so reactivity is unnecessary.
//
// See docs/planning/bug_report_active_context.md.

let _activeLeadId: string | null = null;

export function setActiveLeadId(id: string | null | undefined): void {
  if (typeof id === "string" && id.trim().length > 0) {
    _activeLeadId = id.trim();
  } else {
    _activeLeadId = null;
  }
}

export function clearActiveLeadId(): void {
  _activeLeadId = null;
}

export function readActiveLeadId(): string | null {
  return _activeLeadId;
}

/** Test-only — resets singleton state between runs. */
export function __resetActiveLeadIdForTests(): void {
  _activeLeadId = null;
}
